import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as apiSetting from 'api/apiSettings';
import { useSettings } from 'context/SettingsContext';
import { useToast } from 'context/ToastContext';

type UseSetRateParams = {
    setShow: (show: boolean) => void;
};

export const useSetRate = ({ setShow }: UseSetRateParams) => {
    const { t } = useTranslation(['Rate', 'common']);
    const { showToast } = useToast();
    const { getSettings } = useSettings();
    const [isSetRate, setIsSetRate] = useState(false);

    const submitRate = async (rateValue: string | number) => {
        const rate = Number(rateValue);
        if (!Number.isFinite(rate) || rate < 0) return;

        setIsSetRate(true);
        try {
            const resRate = await apiSetting.setRate(rate);
            await getSettings();

            if (resRate?.stat) {
                showToast(t('messSetRate'), 'success');
                setShow(false);
            } else {
                showToast(t('common:messError'), 'danger');
            }
        } finally {
            setIsSetRate(false);
        }
    };

    return {
        isSetRate,
        submitRate,
    };
};
